import React from "react";
import { Stack } from "@mui/material";
import { PasswordField } from "../../../components/generic/GenericTextFields";
import { SettingsFormLayout } from "./SettingsFormLayout";
import { useFormik } from "formik";
import { object } from "yup";
import { currentPasswordValidation, passwordAndConfrimPasswordValidations } from "../../../helpers/genericFormValidations";
import { updateMyPassword } from "../../../config/apisauce";
import useNotiStack from "../../../hooks/useNotiStack";
import { useLogoutUser } from "../../../components/generic/functions/genericFunctions";
import useStore from "../../../states/store";

export const UpdatePasswordForm = () => {

  const [{ loaderState }, { openLoader, closeLoader }] = useStore();
  const handleLogout = useLogoutUser();
  const { success } = useNotiStack();

  const handleUpdateMyPassword = async (values) => {
    openLoader();
    const response = await updateMyPassword(values);
    if (response.ok) {
      success('Password updated! Please re-login.');
      formik.handleReset();
      handleLogout();
    }
    closeLoader();
  };

  const formik = useFormik({
    initialValues: {},
    enableReinitialize: true,
    validateOnBlur: false,
    validateOnChange: false,
    validationSchema: object().shape({
      ...currentPasswordValidation,
      ...passwordAndConfrimPasswordValidations,

    }),
    onSubmit: (values) => handleUpdateMyPassword(values),
  });

  return (
    <SettingsFormLayout
      title={'Password'}
      subTitle={'Update your password to keep your account secure.'}
      buttonText={'Update Password'}
      action={() => formik.handleSubmit()}
      disabled={loaderState}
    >
      <Stack gap={2}>
        <PasswordField
          value={formik?.values?.current_password}
          label={'Current Password'}
          placeholder={'*********'}
          handleChange={(value) => formik.setFieldValue('current_password', value)}
          error={Boolean(formik?.errors?.current_password)}
          helperText={formik?.errors?.current_password}
        />
        <PasswordField
          value={formik?.values?.password}
          label={'New Password'}
          placeholder={'*********'}
          handleChange={(value) => formik.setFieldValue('password', value)}
          error={Boolean(formik?.errors?.password)}
          helperText={formik?.errors?.password}
        />
        <PasswordField
          value={formik?.values?.password_confirmation}
          label={'Confirm New Password'}
          placeholder={'*********'}
          handleChange={(value) => formik.setFieldValue('password_confirmation', value)}
          error={Boolean(formik?.errors?.password_confirmation)}
          helperText={formik?.errors?.password_confirmation}
        />
      </Stack>
    </SettingsFormLayout>
  )
};